import { render, staticRenderFns } from "./Upd.vue?vue&type=template&id=5cee5c5f"
import script from "./Upd.vue?vue&type=script&lang=js"
export * from "./Upd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports